module.exports = __webpack_public_path__ + "img/finish@2x.74c356b3.png";